import { createBrowserRouter } from "react-router-dom";
import {
  GAIT_AND_BALANCE_INFO,
  HOW_TO_TEST_GAIT_AND_BALANCE,
  HOW_TO_TEST_LEFT_EXTENSION,
  HOW_TO_TEST_LEFT_FLEXION,
  HOW_TO_TEST_RIGHT_EXTENSION,
  HOW_TO_TEST_RIGHT_FLEXION,
  HOW_TO_TEST_TUG_FRONT,
  HOW_TO_TEST_TUG_SIDE,
  LOCOMOTIVE_INFO,
  ROM_DETAILS,
  ROM_INFO,
  ROM_LEFT_EXTENSION,
  ROM_LEFT_FLEXION,
  ROM_RIGHT_EXTENSION,
  ROM_RIGHT_FLEXION,
  ROM_TEST_FLIP,
  TEST_HISTORY,
  TEST_MODULE,
  TUG_FRONT_INFO,
  TUG_SIDE_INFO,
  USER_DETAILS,
  USER_LIST,
} from "./routerPath";
import UserList from "../components/landingPage/userList/UserList";
import Layout from "../Layout";
import UserDetailsPage from "../components/userDetail/UserDetailsPage";
import App from "../App";
import HistoryTab from "../components/userDetail/history/HistoryTab";
import TugSide from "../components/userDetail/testModule/tug/tugSide/TugSide";
import TugFront from "../components/userDetail/testModule/tug/tugFront/TugFront";
import ROMModuleNavTab from "../components/userDetail/testModule/rom/ROMModuleNavTab";
import HowtoTestTugFront from "../components/userDetail/testModule/tug/howToTest/howToTestTugFront/HowtoTestTugFront";
import HowtoTestTugSide from "../components/userDetail/testModule/tug/howToTest/howToTestTugSide/HowtoTestTugSide";
import GaitAndBalance from "../components/userDetail/testModule/gaitAndBalance/GaitAndBalance";
import HowtoTestGaitAndBalance from "../components/userDetail/testModule/gaitAndBalance/howToTest/HowToTestGaitAndBalance";
import HowtoTestLeftFlexion from "../components/userDetail/testModule/rom/howToTest/howToTestLeftFlexion";
import HowtoTestLeftExtension from "../components/userDetail/testModule/rom/howToTest/howToTestLeftExtension";
import HowtoTestRightFlexion from "../components/userDetail/testModule/rom/howToTest/howToTestRightFlexion";
import HowtoTestRightExtension from "../components/userDetail/testModule/rom/howToTest/howToTestRightExtension";
import LocoMotive from "../components/userDetail/testModule/locomotive/LocoMotive";
// import VideoUploading from "../components/userDetail/testModule/videoSaved/VideoUploading";
import TestModule from "../components/userDetail/testModule/TestModule";
import ROMInfoScreen from "../components/userDetail/testModule/rom/ROMInfoScreen";
import ROMLeftFlexion from "../components/userDetail/testModule/rom/ROMLeftFlexion";
import ROMLeftExtension from "../components/userDetail/testModule/rom/ROMLeftExtension";
import ROMRightFlexion from "../components/userDetail/testModule/rom/ROMRightFlexion";
import ROMFlipScreen from "../components/userDetail/testModule/rom/ROMFlipScreen";
import ROMRightExtension from "../components/userDetail/testModule/rom/ROMRightExtension";

const router = createBrowserRouter([
  {
    path: "",
    element: <App />,
    children: [
      {
        path: "",
        element: <Layout />,
        children: [
          {
            path: "/",
            element: <UserList />,
          },
          {
            path: USER_LIST,
            element: <UserList />,
          },
          {
            path: TEST_MODULE,
            element: <TestModule />,
          },
          {
            path: USER_DETAILS,
            element: <UserDetailsPage />,
          },
          {
            path: TUG_SIDE_INFO,
            element: <TugSide />,
          },
          {
            path: TUG_FRONT_INFO,
            element: <TugFront />,
          },
          {
            path: TUG_FRONT_INFO,
            element: <TugFront />,
          },
          {
            path: LOCOMOTIVE_INFO,
            element: <LocoMotive />,
          },
          {
            path: GAIT_AND_BALANCE_INFO,
            element: <GaitAndBalance />,
          },
          {
            path: ROM_INFO,
            element: <ROMModuleNavTab />,
          },
          {
            path: HOW_TO_TEST_TUG_FRONT,
            element: <HowtoTestTugFront />,
          },
          {
            path: HOW_TO_TEST_TUG_SIDE,
            element: <HowtoTestTugSide />,
          },
          {
            path: HOW_TO_TEST_GAIT_AND_BALANCE,
            element: <HowtoTestGaitAndBalance />,
          },
          {
            path: HOW_TO_TEST_LEFT_FLEXION,
            element: <HowtoTestLeftFlexion />,
          },
          {
            path: HOW_TO_TEST_LEFT_EXTENSION,
            element: <HowtoTestLeftExtension />,
          },
          {
            path: HOW_TO_TEST_RIGHT_FLEXION,
            element: <HowtoTestRightFlexion />,
          },
          {
            path: HOW_TO_TEST_RIGHT_EXTENSION,
            element: <HowtoTestRightExtension />,
          },
          {
            path: TEST_HISTORY,
            element: <HistoryTab />,
          },
          {
            path: ROM_DETAILS,
            element: <ROMInfoScreen />,
          },
          {
            path: ROM_LEFT_FLEXION,
            element: <ROMLeftFlexion />,
          },
          {
            path: ROM_LEFT_EXTENSION,
            element: <ROMLeftExtension />,
          },
          {
            path: ROM_TEST_FLIP,
            element: <ROMFlipScreen />,
          },
          {
            path: ROM_RIGHT_FLEXION,
            element: <ROMRightFlexion />,
          },
          {
            path: ROM_RIGHT_EXTENSION,
            element: <ROMRightExtension />,
          },
          // {
          //   path: "/upload-path",
          //   element: <VideoUploading />,
          // },
        ],
      },
    ],
  },
]);
export default router;
